import React from 'react';
import { Navigate } from 'react-router-dom';
// services
import UserService from '../services/UserService';

const SuperAdminRoute = ({ children }) => {
    function isSuperAdmin() {
        const userRole = UserService.getUserRole();
        return userRole==='SUPERADMIN'
    };

    return isSuperAdmin() ? (
        <React.Fragment>
            {children}
        </React.Fragment>
        
    ) : (
        <Navigate to='/contracts' />
    )
};

export default SuperAdminRoute;